<template>
  <div class="brand-index-page">
    <!-- 头部导航 -->
    <div class="page-header">
      <div class="header-content">
        <div class="logo" @click="goHome">
          <img :src="logoUrl" alt="中品指数" />
          <span class="logo-text">中品指数</span>
        </div>
        <nav class="navbar">
          <a href="/" class="nav-link active">首页</a>
        </nav>

        <!-- 已登录：显示头像，点击跳转个人中心 -->
        <img
          v-if="userInfo.userCode"
          class="user-avatar"
          referrerpolicy="no-referrer"
          :src="userInfo.avatar || defaultAvatar"
          alt="个人中心"
          @click="goUserCenter"
        />

        <!-- 未登录：显示登录 -->
        <a v-else href="javascript:;" class="nav-link login-link" @click="goLogin">登录</a>
      </div>
    </div>

    <!-- Banner 背景 -->
    <div class="banner-bg" :style="{ backgroundImage: `url(${backgroundUrl})` }">
      <div class="banner-overlay"></div>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <div class="content-container">
        <!-- 标题 -->
        <h1 class="page-title">中品指数</h1>

        <!-- 搜索框 -->
        <div class="search-box-wrapper">
          <div class="search-box">
            <input
              type="text"
              v-model="searchQuery"
              placeholder="请输入您想查询的关键词"
              ref="searchInput"
            />
            <button class="search-btn" @click="handleSearch">
              <img :src="searchBtnUrl" alt="搜索" v-if="searchBtnUrl" />
              <span v-else>🔍</span>
            </button>
          </div>
          <div class="hot-keys" v-if="!showResult">
            <span v-for="keyword in hotKeywords" :key="keyword" class="hot-key" @click="quickSearch(keyword)">
              {{ keyword }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <div v-if="showLoginDialog" class="login-modal-mask">
      <div class="login-modal-container">
        <LoginCard
          :visible="true"
          :modal-mode="true"
          @close="closeLoginDialog"
          @login-success="handleLoginSuccess"
        />
      </div>
    </div>

  </div>
</template>

<script>
import request from '../detail/api/request'
import LoginCard from '../login/LoginCard.vue'

export default {
  name: 'BrandIndex',
  components: {
    LoginCard
  },
  data() {
    return {
      searchQuery: '',
      showResult: false,
      logoUrl: 'https://image.cbrand.com.cn/default/2026/10/3AAB497BA8984F21A4A68ECE1F55EBF0.png',
      backgroundUrl: 'https://image.cbrand.com.cn/default/2026/10/68EBC26D4AB241129A38284EE003D63D.png',
      searchBtnUrl: 'https://image.cbrand.com.cn/default/2026/10/7E50AAC3620F4CA68C1DB760A491B738.png',
      hotKeywords: ['五常大米', '新会陈皮', '金华火腿', '西湖龙井', '茅台'],
      // 默认头像（在线地址，避免本地路径问题）
      defaultAvatar: 'https://image.cbrand.com.cn/tmp/a35f6d318d63902f817176097c6ca690.png',
      // 用户信息
      userInfo: {
        nickname: '',
        avatar: '',
        userCode: ''
      },
      // 登录弹窗
      showLoginDialog: false
    }
  },
  created() {
    this.loadKeywords()
    this.fetchUserInfo()
  },
  mounted() {
    const keyword = this.$route.query.keyword
    if (keyword) {
      this.searchQuery = keyword
      this.$nextTick(() => {
        this.goToResult()
      })
    }
    // 监听用户信息刷新事件（登录成功后由 LoginCard / 全局派发）
    window.addEventListener('refresh-user-info', this.handleRefreshUserInfo)
  },
  beforeDestroy() {
    window.removeEventListener('refresh-user-info', this.handleRefreshUserInfo)
  },
  methods: {
    handleSearch() {
      if (!this.searchQuery.trim()) return
      this.showResult = true
      this.$nextTick(() => {
        this.goToResult()
      })
    },
    async loadKeywords() {
      console.log('[BrandIndex] Loading keywords...')
      try {
        const res = await request.post('/api/index/getIndexSearchWords')
        console.log('[BrandIndex] Response:', res)
        if (res.code === 200 && res.data) {
          console.log('[BrandIndex] Loaded keywords:', res.data)
          this.hotKeywords = res.data.split(',')
        }
      } catch (error) {
        console.error('加载热门关键词失败', error)
      }
    },
    quickSearch(keyword) {
      this.searchQuery = keyword
      this.handleSearch()
    },
    goToResult() {
      this.$router.push({
        path: '/brand-result',
        query: { keyword: this.searchQuery }
      })
    },

    // ========== 登录 / 用户信息相关 ==========
    // 点击登录：打开登录弹窗
    goLogin() {
      console.log('[BrandIndex] goLogin called, opening login dialog')
      this.showLoginDialog = true
    },

    // 关闭登录弹窗
    closeLoginDialog() {
      console.log('[BrandIndex] closing login dialog')
      this.showLoginDialog = false
    },
 goHome() {
      this.$router.push('/')
    },
    // 登录成功回调
    handleLoginSuccess() {
      console.log('[BrandIndex] login success, refreshing user info')
      this.closeLoginDialog()
      // 通知全局刷新用户信息（PageHeader 等会监听）
      window.dispatchEvent(new CustomEvent('refresh-user-info'))
      // 自己刷新头像
      this.fetchUserInfo()
    },

    // 全局用户信息刷新事件
    handleRefreshUserInfo() {
      console.log('[BrandIndex] refresh-user-info event received')
      this.fetchUserInfo()
    },

    // 拉取用户信息（区分个人 / 企业账号）
    async fetchUserInfo() {
      const token = localStorage.getItem('token')
      console.log('[BrandIndex] fetchUserInfo called, token exists:', !!token)
      if (!token) {
        this.userInfo = { nickname: '', avatar: '', userCode: '' }
        return
      }
      try {
        const userType = localStorage.getItem('userType') || 'personal'
        let data = {}
        if (userType === 'company') {
          // 企业账号
          const res = await request.post('/api/company/home/getCompanyInfo')
          data = res.data || {}
          this.userInfo = {
            nickname: data.companyShortName || '',
            avatar: data.avatar || '',
            userCode: data.companyCode || ''
          }
        } else {
          // 个人账号（默认）
          const res = await request.post('/api/member/home/getUserInfo')
          data = res.data || {}
          this.userInfo = {
            nickname: data.nickname || '',
            avatar: data.avatar || '',
            userCode: data.userCode || ''
          }
        }
        console.log('[BrandIndex] User info loaded:', this.userInfo)
      } catch (e) {
        console.error('[BrandIndex] Failed to fetch user info:', e)
        // token 无效或过期，清除
        localStorage.removeItem('token')
        this.userInfo = { nickname: '', avatar: '', userCode: '' }
      }
    },

    // 点击头像跳转个人中心
    goUserCenter() {
      this.$router.push('/my')
    }
  }
}
</script>

<style scoped>
.brand-index-page {
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

/* 头部导航 */
.page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 1000;
}

.header-content {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 40px;
  box-sizing: border-box;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-right: 60px;
}

.logo img {
  height: 40px;
  width: auto;
}

.logo-text {
  font-size: 20px;
  font-weight: bold;
  color: #C00513;
}

.navbar {
  display: flex;
  gap: 40px;
  margin-right: auto;
}

.nav-link {
  font-size: 15px;
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
  position: relative;
  padding-bottom: 4px;
  cursor: pointer;
}

.nav-link:hover {
  color: #1ba6e2;
}

.nav-link.active {
  color: #1ba6e2;
  font-weight: 500;
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #1ba6e2;
}

.nav-link:not(.active)::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: #1ba6e2;
  transition: width 0.3s;
}

.nav-link:not(.active):hover::after {
  width: 100%;
}

.login-link {
  color: #333 !important;
  font-weight: 600 !important;
  white-space: nowrap;
}

/* 已登录头像 */
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  border: 1px solid #eee;
  transition: box-shadow 0.2s, transform 0.2s;
  flex-shrink: 0;
}
.user-avatar:hover {
  box-shadow: 0 2px 12px rgba(27, 166, 226, 0.35);
  transform: translateY(-1px);
}

/* Banner 背景 */
.banner-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: -1;
}

.banner-overlay {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.4) 40%, rgba(255,255,255,0) 100%);
}

/* 主内容区 */
.main-content {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 64px;
  padding-left: 10%;
  box-sizing: border-box;
}

.content-container {
  width: 100%;
  max-width: 1400px;
  text-align: left;
  padding: 0 20px;
  margin-left: 120px;
  margin-top: -120px;
}

.page-title {
  width: 243px;
  height: 63px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 48px;
  color: #000000;
  letter-spacing: 4px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 12px;
  margin-bottom: 40px;
}

/* 搜索框 */
.search-box-wrapper {
  max-width: 600px;
  margin: 0;
}

.search-box {
  display: flex;
  gap: 0;
  height: 56px;
  background: #fff;
  border-radius: 28px;
  padding: 4px;
  box-shadow: 0 4px 20px rgba(27, 166, 226, 0.15);
  border: 1px solid #e0e0e0;
}

.search-box input {
  flex: 1;
  height: 100%;
  padding: 0 24px;
  border: none;
  border-radius: 28px;
  font-size: 16px;
  outline: none;
  background: transparent;
  color: #333;
}

.search-box input::placeholder {
  color: #999;
}

.search-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  padding: 0;
  margin: auto 4px;
}

.search-btn:hover {
  background: #f0f9fd;
}

.search-btn img {
  width: 24px;
  height: 24px;
}

.hot-keys {
  margin-top: 20px;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.hot-key {
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
  padding: 4px 12px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.8);
}

.hot-key:hover {
  color: #1ba6e2;
  background: #f0f9fd;
  transform: translateY(-2px);
}

/* 结果页提示 */
.result-trigger {
  margin-top: 40px;
  margin-left: 10%;
  padding: 12px 32px;
  background: linear-gradient(135deg, #1ba6e2 0%, #168dbd 100%);
  color: #fff;
  border-radius: 28px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 16px rgba(27, 166, 226, 0.3);
  display: inline-block;
}

.result-trigger:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(27, 166, 226, 0.4);
}

/* ========== 登录弹窗遮罩层 ========== */
.login-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-modal-container {
  position: relative;
  animation: modal-fade-in 0.3s ease;
}

@keyframes modal-fade-in {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .header-content {
    padding: 0 16px;
  }
  .logo {
    margin-right: 20px;
  }
  .navbar {
    gap: 20px;
  }
  .main-content {
    padding-left: 20px;
    justify-content: center;
    text-align: center;
  }
  .content-container {
    text-align: center;
    margin-left: 0;
  }
  .search-box-wrapper {
    margin: 0 auto;
  }
  .hot-keys {
    justify-content: center;
  }
  .result-trigger {
    margin-left: 0;
  }
  .page-title {
    font-size: 36px;
    margin-left: 0;
  }
}
</style>